import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { UserConsumer } from './providers/UserProvider';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withWidth from '@material-ui/core/withWidth';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';

class Release extends Component {

  render() {

    const { width, classes, theme } = this.props;

    return (
      <UserConsumer>
        {({ acknowledgeRelease }) => {
          return <div
            className={classes.infoBar}
            data-test="release-bar"
            style={{
              color: theme.palette.primary.main,
              backgroundColor: theme.palette.secondary.main
            }}>
            <div className={classes.infoBarIcon}>
              <AnnouncementIcon />
            </div>
            <div className={classes.infoBarMessage}>
              <Typography variant="body2">
                {width !== "xs" && width !== "sm" &&
                  <span>We have updated to version {process.env.REACT_APP_VERSION}. </span>
                }
                <span style={{ fontWeight: 500, marginLeft: 20 }}>
                  <a href={"https://graphologi.com/release"} target="_blank" rel="noreferrer">VIEW RELEASE NOTES</a>
                </span>
              </Typography>
            </div>
            <div className={classes.infoBarAction}>
              <Tooltip title="Close notification">
                <IconButton size="small" onClick={acknowledgeRelease}>
                  <CloseIcon data-test="hide-release-bar" style={{ color: theme.palette.primary.main }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>;
        }}
      </UserConsumer>
    );
  }
}

Release.propTypes = {
  width: PropTypes.string,
  theme: PropTypes.object,
  acknowledgeRelease: PropTypes.func,
  classes: PropTypes.object
};

export default withWidth()(withTheme(withStyles(styles)(Release)));
